<template>
  <b-row class="group-tree-select-wrapper">
    <b-col cols="12">
      <div class="group-tree-select-row">
        <treeselect
          ref="treeselect"
          name="group-tree-select"
          :placeholder="
            loading && groupsTree.length === 0
              ? labels.loading
              : user.companyName
          "
          :clearValueText="labels.cleanFilter"
          :noOptionsText="labels.wait"
          :noResultsText="labels.searchNotFound"
          showCountOf="ALL_DESCENDANTS"
          :options="groupsTree"
          :clearable="clearable"
          :searchable="searchable"
          :open-on-click="openOnClick"
          :open-on-focus="openOnFocus"
          :close-on-select="closeOnSelect"
          :show-count="showCount"
          :always-open="alwaysOpen"
          :value="selectedGroup"
          @input="updateSelectedGroup"
        >
          <label
            slot="option-label"
            slot-scope="{
              node,
              shouldShowCount,
              count,
              labelClassName,
              countClassName,
            }"
            :class="labelClassName"
          >
            <span
              :title="node.label"
              :class="{ 'inactive-group': node.raw.inactive }"
            >
              {{ node.label }}
            </span>
            <span v-if="shouldShowCount" :class="countClassName">
              ({{ count }})
            </span>
          </label>
          <div slot="value-label" slot-scope="{ node }">
            <span :class="{ 'inactive-group': node.raw.inactive }">
              {{ node.label }}
            </span>
          </div>
        </treeselect>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { getUser, isBasicPlan } from '@/service/user'

export default {
  components: { Treeselect },
  data() {
    return {
      loading: false,
      value: null,
      clearable: true,
      searchable: true,
      openOnClick: true,
      openOnFocus: true,
      closeOnSelect: true,
      showCount: true,
      alwaysOpen: false,
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
      groupsTree: 'user/groupsTree',
      selectedGroup: 'user/selectedGroup',
    }),

    user() {
      return getUser()
    },

    labels() {
      return this.resources.component.groupsTreeSelect
    },
  },
  created() {
    this.loadGroupsTree()

    const groupId = this.$route.params.groupId || 'company'
    const selectedGroup = this.selectedGroup
    if (!selectedGroup && groupId !== 'company') {
      this.$store.dispatch('user/updateSelectedGroup', groupId)
    }
  },
  methods: {
    updateSelectedGroup(value) {
      this.$store.dispatch('user/updateSelectedGroup', value)

      const isCompany = value === undefined

      const _id = isCompany ? 'company' : value
      const inactive = isCompany
        ? false
        : this.$refs['treeselect'].getNode(value).raw.inactive

      this.$emit('selectItem', { _id, inactive, enable: !isBasicPlan() })
    },
    async loadGroupsTree() {
      this.loading = true
      await this.$store.dispatch('user/loadGroupsTree')
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.group-tree-select-wrapper {
  flex-grow: 1;
  max-width: 550px;

  .group-tree-select-row {
    display: flex;
    flex-direction: column;

    .clearable-icon {
      font-size: 1.8rem;
    }

    /deep/ .vue-treeselect {
      font-size: 1.1rem;

      .vue-treeselect__menu {
        overflow-x: auto;
      }

      .vue-treeselect__placeholder {
        margin-top: 7px;
        color: map-get($theme-colors, 'primary') !important;
      }

      .vue-treeselect__control {
        height: 50px !important;
        box-shadow: 0px 2px 0px 1px map-get($theme-colors, 'gray08');

        .vue-treeselect__input {
          background-color: map-get($theme-colors, 'white') !important;
        }
      }

      .vue-treeselect__label-container {
        .vue-treeselect__label {
          overflow: inherit;

          .inactive-group {
            color: map-get($theme-colors, 'gray01');
          }
        }
      }

      .vue-treeselect__option--selected {
        background-color: map-get($theme-colors, 'gray08');

        .inactive-group {
          font-weight: normal;
          color: map-get($theme-colors, 'gray02');
        }
      }

      .vue-treeselect__single-value {
        margin-top: 7px;

        .inactive-group {
          color: map-get($theme-colors, 'gray01');
        }
      }
    }
  }
}
</style>
